import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 0px;
  @media (max-width: 900px) {
    margin: 12px 0px;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 18px;

  h6 {
    font-size: 1rem;
    letter-spacing: 0px;
    @media (max-width: 900px) {
      font-size: .9rem;
    }
  }
  span {
    color: #4b4b4b;
    font-size: .75rem;
    font-weight: normal;
  }
`;

const ToggleContainer = styled.div`
  cursor: pointer;
  position: relative;
`;

const ToggleBackground = styled.div`
  background: ${(props) =>
    props.checked ? props.theme.color.primaryGradient : "#d7dde8"};
  box-shadow: ${(props) => (props.checked ? `0px 0px 8px ${props.theme.color.primary};` : "none")};
  border-radius: 100px;
  height: 28px;
  width: 51px;
  transition: 0.2s ease all;
`;

const ToggleThumb = styled.div`
    background: #FFF;
    border-radius: 100px;
    height: 24px;
    width: 24px;
    position: absolute;
    top: 50%;
    left: ${(props) => (props.checked ? "calc(100% - 27px)" : "3px")};
    transform: translateY(-50%);
    transition: 0.2s ease all;
`;

export const Toggle = (props) => {
  return (
    <Container>
      <ToggleContainer onClick={props.onChange}>
        <ToggleBackground checked={props.checked} />
        <ToggleThumb checked={props.checked} />
      </ToggleContainer>
      <Text>
        <h6>
          {props.label}
        </h6>
        <span>{props.note}</span>
      </Text>
      
    </Container>
  );
};
